import { Patterns } from "../patterns.svg.model";
import { BlurProperties, FormType, Option, Properties, TextureProperties } from "../properties.model";
import { EffectsType } from "../ui-effects.model";


const textureOptions: Option[] = Object.values(Patterns).map((key => ({label: key, value: key})))

export const textureForm: Properties = {
  propertyType: EffectsType.Texture,
  label: 'Texture',
  forms: [
    {
      id: TextureProperties.TextureSelector,
      label: 'Texture Selector',
      type: FormType.Select,
      options: textureOptions,
      defaultValue: {label: 'Normal', value: 'normal'}
    },
    {
      id: TextureProperties.TextureColor,
      label: 'Color',
      type: FormType.Color,
      placeholder: "#Hex Color",
      defaultValue: '#FFFFFF'
    },
    {
      id: TextureProperties.TextureOpacity,
      label: 'Opacity',
      type: FormType.SliderNumber,
      defaultValue: 1,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
    {
      id: TextureProperties.TextureScale,
      label: 'Scale',
      type: FormType.SliderNumber,
      defaultValue: 1,
      sliderOptions: {
        min: .01,
        max: 1,
        step: 0.01
      }
    },
    {
      id: TextureProperties.TextureHideUnderlyingLayer,
      label: 'Hide Underlying Layer',
      type: FormType.Checkbox,
      defaultValue: false
    },
  ],
  changeHandler: () => {}
}
